var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.504,
    height: 14.256,
    viewBox: "0 0 9.504 14.256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.477,198.219a.506.506,0,0,0,.608-.184l5.325-7.615a.486.486,0,0,0,.037-.516.519.519,0,0,0-.447-.27l-3.3-.025.956-5.011a.5.5,0,0,0-.894-.405l-5.647,7.037a.484.484,0,0,0-.062.528.511.511,0,0,0,.459.282l3.649.025-.981,5.6A.482.482,0,0,0,57.477,198.219Z",
    transform: "translate(-54 -183.999)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.71287975.svg";
export { ForwardRef as ReactComponent };